const createMarkup = (__html: string) => ({ __html })

export default createMarkup
